import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { LANGUAGE_CHIP_LABELS } from 'src/data/generation';

import { CustomChip } from '../CustomChip';

import { useStyles } from './useStyles';


export const BrandVoiceLanguageTag = ({ className, brandVoice, disabled }) => {
  const styles = useStyles();

  if (!brandVoice?.language) {
    return null;
  }

  return (
    <CustomChip
      className={cx(styles.root, className, { [styles.disabled]: disabled })}
      label={LANGUAGE_CHIP_LABELS[brandVoice?.language]}
      disabled={disabled}
    />
  );
};

BrandVoiceLanguageTag.propTypes = {
  brandVoice: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    language: PropTypes.string,
  }).isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
};

BrandVoiceLanguageTag.defaultProps = {
  className: '',
  disabled: false,
};
